import apiFetch from '../../apiFetch'

export default function (idIntervencion, token) {
  return apiFetch({endPoint: `Intervencion/getIntervencion?idIntervencion=${idIntervencion}`, method: 'GET', body: null, token: token})
}
